import { Subtitle } from "core/models";

export const convertSrtTimecodeToTimefloat = (timecode: string): number => {
    if (!timecode) {
        return 0;
    }
    const re = /[:.,]/gm;
    const [, minutes, seconds, miliseconds] = timecode.split(re);
    return +minutes * 60 + +seconds + +miliseconds / 1000;
};

const parseVttSubtitles = (data: string): Subtitle[] => {
    const re = /(\d{2}:\d{2}:\d{2}.\d{3})/gm;
    let dataArr = data.split(re);
    dataArr = dataArr.filter((e) => e !== "WEBVTT\r\n\r\n" && e !== " --> ");
    const subtitleArr: Subtitle[] = [];
    for (let i = 0; i < dataArr.length; i += 3) {
        const sub: Subtitle = {
            id: Math.round(Math.random() * 100000),
            startTime: convertSrtTimecodeToTimefloat(dataArr[i]),
            endTime: convertSrtTimecodeToTimefloat(dataArr[i + 1]),
            text: `${dataArr[i + 2].replace(/\r\n/g, "")}`,
        };
        subtitleArr.push(sub);
    }
    return subtitleArr;
};
export default parseVttSubtitles;
